import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "print-only filter-tiles-container" }

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { format } from 'date-fns';
import { useReportFiltersStore } from '@/stores/reports/useReportFiltersStore';


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'ReportFilterTiles',
  setup(__props) {



const store = useReportFiltersStore();
const { panel } = storeToRefs(store);
// What the report applies, not what other reports left in the store.
const filters = computed(() => store.visibleFilters(panel.value.show));

const formatDate = (date: Date | string | null | undefined) =>
  date ? format(new Date(date), 'MM/dd/yy') : '';

const dateRangeText = computed(() => {
  const { printFilterTime } = panel.value;
  if (printFilterTime) {
    return typeof printFilterTime === 'string'
      ? printFilterTime
      : formatDate(printFilterTime);
  }
  const period = filters.value.dateRange;
  if (!period) return '';
  if (period.label === 'All Time') return 'All Time';
  const { startDate, endDate } = period.range;
  if (!startDate) return `Through ${formatDate(endDate)}`;
  return `${formatDate(startDate)} - ${formatDate(endDate)}`;
});

const tiles = computed(() => {
  const { family, show } = panel.value;
  const { billed, status, trustAccount, distributionId } = filters.value;
  const standard = family === 'standard';
  const candidates = [
    {
      key: 'dateRange',
      text: dateRangeText.value,
      visible: standard || show.dateRange,
    },
    {
      key: 'billed',
      text: billed?.label,
      visible: standard || (show.billed && !distributionId),
    },
    {
      key: 'archived',
      text: status?.label,
      visible: standard || show.archivedStatus || show.matterForUser,
    },
    {
      key: 'trustAccount',
      text: trustAccount?.name,
      visible: !standard && show.trustAccount,
    },
  ];
  return candidates.filter((t) => t.visible && t.text);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiles.value, (tile) => {
      return (_openBlock(), _createElementBlock("div", {
        key: tile.key,
        class: "filter-tile"
      }, _toDisplayString(tile.text), 1))
    }), 128))
  ]))
}
}

})